// TODO: SET Default Categories on Admin Panel SETTINGS
export const mainCategories = {
  Place: '5e6f4026e07c2924e4f80b30',
  Gender: '5e6f98b31e485b51a486194a',
  Preferences: '5e6f4026e07c2924e4f80b31',
  Levels: '5e6f52078527282058a2ffb4',
};

export const categoriesIds = [
  mainCategories.Place,
  mainCategories.Gender,
  mainCategories.Preferences,
  mainCategories.Levels,
];

export enum LevelsIDs {
  Level1 = '5e6f8822b456c4214887c6f0',
  Level2 = '5e6f93d27668841db072b24f',
  Level3 = '5e6f93d27668841db072b250',
}

export enum GenderIds {
  Man = '5e6f991c1e485b51a486194b',
  Woman = '5e6f991c1e485b51a486194c',
}
